import { ChangeDetectionStrategy, Component } from '@angular/core';
import { injectContext } from '@taiga-ui/polymorpheus';
import { MessageMaintenance } from '../../models/message-maintenance';
import { MessageMaintenanceFormComponent } from '../message-maintenance-form/message-maintenance-form.component';
import { TuiDialogContext } from '@taiga-ui/core';

@Component({
  selector: 'app-message-maintenance-modal',
  standalone: true,
  imports: [
    MessageMaintenanceFormComponent,
  ],
  templateUrl: './message-maintenance-modal.component.html',
  styleUrl: './message-maintenance-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageMaintenanceModalComponent {
  public readonly context = injectContext<TuiDialogContext<boolean, { messageMaintenance: MessageMaintenance | undefined, onClose: () => void, refreshList: () => void }>>();

  public messageMaintenance!: MessageMaintenance | undefined;
  public onClose!: () => void;
  public refreshList!: () => void;

  ngOnInit(): void {
    this.messageMaintenance = this.context.data.messageMaintenance;
    this.onClose = this.context.data.onClose;
    this.refreshList = this.context.data.refreshList;
  }
}